import { QuotationTask } from '@/hooks/api/models';
import axios from '@/lib/axios';
import { useMutation } from '@tanstack/react-query';

/**
 * 1490. 見積タスクフェーズ更新（次へ）
 * [PUT] /workspaces/:identifier/teams/:team_id/sales_orders/:sales_order_id/quotation_tasks/:quotation_task_id/move_to_next_phase
 */
type Props = {
  identifier: string;
  team_id: number;
  sales_order_id: number;
  task_id: number;
  current_quotation_task_phase_id: number;
};

const moveQuotationTaskPhaseToNext = (props: Props): Promise<QuotationTask> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/sales_orders/${props.sales_order_id}/quotation_tasks/${props.task_id}/move_to_next_phase`,
    props
  );
};

export const useMoveQuotationTaskPhaseToNext = () => {
  return useMutation({
    mutationFn: moveQuotationTaskPhaseToNext
  });
};